import styled from 'styled-components';

export default styled.nav``;
